import MsgManagerVue from '@/views/sic/msg-manager/msg-manager.vue';

const basePath = '/sic/msg-manager';
const role = 'sic'; // 角色身份

export const SIC_MSG_MANAGER_INDEX = 'sic-msg-manager-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MsgManagerVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_MSG_MANAGER_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/msg-manager/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
